export default __webpack_public_path__ + "static/media/login-img-1.dd5db134.jpeg";